import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useQuery } from 'react-query';
import { debounce } from 'lodash';
import { Row, Col } from 'react-bootstrap';
import {
  CRUDLayout,
  Alert,
  DataStatus,
  ReadButton,
  InputSearch,
  Pagination,
  Table,
  THead,
  TBody,
  Tr,
  ThFixed,
  TdFixed,
  Th,
  Td,
  ApprovalStatusButton,
} from 'components';
import { DateConvert, PageNumber as TableNumber } from 'utilities';
import { PurchaseRequestApi } from 'api';
import { tglInputFormat } from '../Utils';
import { refetchInterval } from 'config/refetchInterval';

const HistoryApprovalPurchaseRequest = () => {
  const history = useHistory();
  const location = useLocation();

  const [pagination, setPagination] = useState({
    q: '',
    page: '1',
    per_page: '10',
  });

  const [alertConfig, setAlertConfig] = useState({
    show: false,
    variant: 'primary',
    text: '',
  });

  const checkAlert = () => {
    const locationState = location.state;

    if (locationState) {
      if (locationState.alert) {
        setAlertConfig({
          show: locationState.alert.show,
          text: locationState.alert.text,
          variant: locationState.alert.variant,
        });
      }
    }
  };

  const { data, isLoading } = useQuery(
    ['history', 'purchaseRequest', 'list', pagination],
    () => PurchaseRequestApi.getHistory(pagination),
    {
      refetchInterval,
      onError: () =>
        setAlertConfig({
          show: true,
          variant: 'danger',
          text: 'Data gagal dimuat',
        }),
    }
  );

  const searchHandler = (e) => {
    const searchKey = e.target.value ? e.target.value : undefined;

    setPagination({
      ...pagination,
      q: searchKey,
      page: '1',
    });
  };

  const onPaginationChange = ({ selected }) =>
    setPagination({ ...pagination, page: selected + 1 });

  const onDataLengthChange = (e) =>
    setPagination({ ...pagination, page: 1, per_page: e.target.value });

  const checkStatus = (stat) => {
    let data = stat ? stat.toUpperCase() : '';
    const convert = data.substring(0, 3);

    if (convert === 'APP') {
      return {
        variant: 'outline-success',
        label: 'APPROVED',
      };
    }
    if (convert === 'VER') {
      return {
        variant: 'outline-success',
        label: 'VERIFIED',
      };
    }
    if (convert === 'REV') {
      return {
        variant: 'outline-warning',
        label: 'REVISION',
      };
    }
    if (convert === 'REJ') {
      return {
        variant: 'outline-danger',
        label: 'REJECTED',
      };
    }
    return {
      variant: 'outline-secondary',
      label: 'PENDING',
    };
  };

  useEffect(() => {
    checkAlert();
  }, []);

  const PageContent = () => {
    const ItemBarangCollapse = ({ data }) => {
      const [isReadMoreClick, setisReadMoreClick] = useState(false);

      return (
        <>
          <ul className="pl-3 mb-1" style={{ fontSize: '12px' }}>
            {data.map((brg, index) => {
              if (isReadMoreClick) {
                return (
                  <li key={index} index={index}>
                    {`${brg.nama_item} ${brg.qty ? brg.qty : ''} ${
                      brg.nama_satuan ? brg.nama_satuan : ''
                    }` ?? '-'}
                  </li>
                );
              } else {
                return (
                  index <= 1 && (
                    <li key={index} index={index}>
                      {`${brg.nama_item} ${brg.qty ? brg.qty : ''} ${
                        brg.nama_satuan ? brg.nama_satuan : ''
                      }` ?? '-'}
                    </li>
                  )
                );
              }
            })}
          </ul>
          {data.length > 2 ? (
            <div
              className="text-primary"
              style={{
                cursor: 'pointer',
                textDecoration: 'underline',
                // fontWeight: "bold",
              }}
              onClick={() => {
                setisReadMoreClick((prev) => !prev);
              }}
            >
              {isReadMoreClick ? 'Sembunyikan' : 'Selengkapnya...'}
            </div>
          ) : (
            ''
          )}
        </>
      );
    };
    const DataTable = () => (
      <Table>
        <THead>
          <Tr>
            <ThFixed>No</ThFixed>
            <Th width={250}>Informasi Pembuat Pengajuan</Th>
            <ThFixed>Tgl. Input Data</ThFixed>
            <ThFixed>Informasi Purchase Request</ThFixed>
            <Th>Item Barang</Th>
            <ThFixed>Keperluan</ThFixed>
            <ThFixed>Tgl. Pemakaian</ThFixed>
            <ThFixed>Status Approval</ThFixed>
            <ThFixed>Aksi</ThFixed>
          </Tr>
        </THead>
        <TBody>
          {data?.data?.data?.map((val, index) => (
            <Tr key={index}>
              <TdFixed>
                {TableNumber(pagination.page, pagination.per_page, index)}
              </TdFixed>
              <Td>
                <div>
                  {val.nama_karyawan ?? val.nama_karyawan_pengaju ?? '-'}
                </div>
                <div>{val.nama_jabatan ?? val.nama_jabatan_pengaju ?? '-'}</div>
              </Td>
              <Td className="text-nowrap">
                {tglInputFormat({
                  created_at: val.created_at,
                  separator: ' - ',
                })}
              </Td>
              <TdFixed>
                <div className="text-left">
                  {val.tgl_purchase_request
                    ? DateConvert(new Date(val.tgl_purchase_request)).custom
                    : '-'}
                </div>
                <div className="text-left">
                  {val.no_purchase_request ? val.no_purchase_request : '-'}
                </div>
              </TdFixed>
              <Td>
                {val.item_barang ? (
                  val.item_barang.length > 0 ? (
                    <ItemBarangCollapse data={val.item_barang} />
                  ) : (
                    '-'
                  )
                ) : (
                  '-'
                )}
              </Td>
              <TdFixed>
                <span className="text-capitalize">
                  {val.keperluan ? val.keperluan : '-'}
                </span>
              </TdFixed>
              <TdFixed>
                {val.tgl_pemakaian
                  ? DateConvert(new Date(val.tgl_pemakaian)).custom
                  : '-'}
              </TdFixed>
              <TdFixed>
                <ApprovalStatusButton
                  variant={checkStatus(val.status_approval).variant}
                >
                  {checkStatus(val.status_approval).label}
                </ApprovalStatusButton>
              </TdFixed>
              <TdFixed>
                <div className="d-flex justify-content-center">
                  <ReadButton
                    onClick={() =>
                      history.push(
                        '/human-resource/approval/purchase-request/detail/' +
                          val.id_purchase_request,
                        {
                          no_purchase_request: val.no_purchase_request,
                          tab: 'history',
                        }
                      )
                    }
                  />
                </div>
              </TdFixed>
            </Tr>
          ))}
        </TBody>
      </Table>
    );

    return (
      <>
        <DataTable />
        <Pagination
          dataLength={pagination.per_page}
          dataNumber={
            pagination.page * pagination.per_page - pagination.per_page + 1
          }
          dataPage={
            data?.data?.data_count < pagination.per_page
              ? data?.data?.data_count
              : pagination.page * pagination.per_page
          }
          dataCount={data?.data?.data_count}
          currentPage={pagination.page}
          totalPage={data?.data?.total_page}
          onPaginationChange={onPaginationChange}
          onDataLengthChange={onDataLengthChange}
        />
      </>
    );
  };

  return (
    <CRUDLayout>
      {/* head section */}
      <CRUDLayout.Head>
        <CRUDLayout.HeadSearchSection>
          <Row className="mb-2">
            <Col md={8}>
              <InputSearch onChange={debounce(searchHandler, 1500)} />
            </Col>
          </Row>
        </CRUDLayout.HeadSearchSection>
        <CRUDLayout.HeadButtonSection></CRUDLayout.HeadButtonSection>
      </CRUDLayout.Head>

      {/* alert */}
      <Alert
        show={alertConfig.show}
        variant={alertConfig.variant}
        text={alertConfig.text}
        showCloseButton={true}
        onClose={() =>
          setAlertConfig({
            ...alertConfig,
            show: false,
          })
        }
      />

      {/* content */}
      {isLoading ? (
        <DataStatus loading={true} text="Memuat data . . ." />
      ) : data.data.data.length > 0 ? (
        <PageContent />
      ) : (
        <DataStatus text="Tidak ada data" />
      )}
    </CRUDLayout>
  );
};

export default HistoryApprovalPurchaseRequest;
